function timestampMs(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : Infinity;
  if (typeof value !== "string" || !value.trim()) return Infinity;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : Infinity;
}

export function orderWaitingReplies(items) {
  return (items || [])
    .map((item, index) => ({ item, index, timestamp:timestampMs(item?.waitingAt) }))
    .sort((a, b) => (a.timestamp - b.timestamp) || (a.index - b.index))
    .map(entry => entry.item);
}